import React from 'react';
import { Modal } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import CloseButton from '@/components/buttons/CloseButton';
import SaveButton from '@/components/buttons/SaveButton';
import { transformForm } from '@/forms/state/state';
import { validateRequestTaskSection } from '../forms/helper';
import Events from '../hooks/events';
import TaskClaimButton from './TaskClaimButton';
import Selectors from '../hooks/selectors';

const TaskRequestFormActions = () => {
  const state = Selectors.useTaskRequestFormActions();
  const hide = Events.useHideRequestTask();
  const submitForm = Events.useSaveRequestTask();
  const completeForm = Events.useCompleteRequestTask();
  const updateProperties = Events.useUpdateActiveTaskProperties();
  const disabled = [state.saveStatus, state.completeStatus, state.claimStatus].includes(states.PENDING);

  const validateAndAct = (action) => {
    const form = transformForm(state.fields);
    const saveErrors = [
      validateRequestTaskSection(form, state, 'task'),
      validateRequestTaskSection(form, state, 'comments'),
    ].flat();
    updateProperties({ properties: { saveErrors } });

    if (saveErrors.length === 0) {
      action();
    }
  };

  return (
    <>
      {(!state.canEdit) && (
        <Modal.Actions>
          <CloseButton messageId="actions.close" onClick={hide} />
        </Modal.Actions>
      )}
      {(state.canEdit) && (
        <Modal.Actions>
          {(state.canClaim) && (
            <div className="float-l">
              <TaskClaimButton
                disabled={disabled || state.isDirty}
                claimStatus={state.claimStatus}
                silent
                task={state}
              />
            </div>
          )}
          <div>
            <CloseButton onClick={hide} disabled={disabled} />
            <SaveButton
              disabled={disabled}
              inProgress={state.saveStatus === states.PENDING}
              minimumDataEntryMet={state.isDirty}
              onClick={() => validateAndAct(submitForm)}
              secondary
              messageId="actions.save"
            />
            <SaveButton
              disabled={disabled}
              inProgress={state.completeStatus === states.PENDING}
              minimumDataEntryMet
              onClick={() => validateAndAct(completeForm)}
              messageId="actions.complete"
            />
          </div>
        </Modal.Actions>
      )}
    </>
  );
};

export default TaskRequestFormActions;
